package app.nestbridge.feature.invitations.api.model

import app.nestbridge.domain.identity.api.model.ProfessionalServiceTypeDto
import app.nestbridge.feature.careteam.api.model.TeamRelationshipRoleDto
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class InvitationDto(
    val id: String,
    val status: InvitationStatusDto,
    val inviterUserProfileId: String,
    val inviterDisplayName: String,
    val inviterOrganizationName: String? = null,
    val inviterOrganizationType: OrganizationTypeDto? = null,
    val childId: String,
    val childDisplayName: String,
    val teamId: String?,
    val teamType: ProfessionalServiceTypeDto?,
    val proposedTeamRole: TeamRelationshipRoleDto,
    val grantsChildStewardship: Boolean,
    val deliveryMethod: InvitationDeliveryMethodDto,
    val deliveryDestination: String?,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
)
